import { useEffect } from 'react';

export interface KeyboardShortcut {
    key: string;
    shift?: boolean;
    ctrl?: boolean;
    alt?: boolean;
    meta?: boolean;
    /** Determines if the shortcut still has effect if the focus is on an input or editable field */
    allowInInput?: boolean;
    action: () => void;
}

/**
 * ⓪ ① ② ③ ④ ⑤ ⑥ ⑦ ⑧ ⑨
 */
export function useKeyboardShortcuts(shortcuts: KeyboardShortcut[]) {
    useEffect(() => {
        function onKeyDown(event: KeyboardEvent) {
            const target = event.target as HTMLElement | null;
            const isEditable =
                target?.isContentEditable ||
                target?.tagName === 'INPUT' ||
                target?.tagName === 'TEXTAREA' ||
                target?.tagName === 'SELECT';

            const shortcut = shortcuts.find(candidate =>
                event.key.toLowerCase() === candidate.key.toLowerCase() &&
                event.shiftKey === Boolean(candidate.shift) &&
                event.ctrlKey === Boolean(candidate.ctrl) &&
                event.altKey === Boolean(candidate.alt) &&
                event.metaKey === Boolean(candidate.meta),
            );

            if (event.repeat || !shortcut || (isEditable && !shortcut.allowInInput)) {
                return;
            }

            event.preventDefault();
            shortcut.action();
        }

        document.addEventListener('keydown', onKeyDown);

        return () => document.removeEventListener('keydown', onKeyDown);
    }, [shortcuts]);
}
